/** sessionStorage handoff from Lore → Tutorials to the target menu screen */
export const REPLAY_MENU_TUTORIAL_STORAGE_KEY = 'coda_replay_menu_tutorial';

export function setReplayMenuTutorialRequest(messageKey) {
  if (!messageKey || typeof messageKey !== 'string') {
    throw new Error('setReplayMenuTutorialRequest requires a non-empty messageKey string');
  }
  sessionStorage.setItem(REPLAY_MENU_TUTORIAL_STORAGE_KEY, messageKey);
}

/**
 * @param {string} expectedKey
 * @returns {boolean} true if this screen should replay that tutorial (key removed from storage)
 */
export function consumeReplayMenuTutorialRequest(expectedKey) {
  const pending = sessionStorage.getItem(REPLAY_MENU_TUTORIAL_STORAGE_KEY);
  if (pending !== expectedKey) {
    return false;
  }
  sessionStorage.removeItem(REPLAY_MENU_TUTORIAL_STORAGE_KEY);
  return true;
}
